export default "__VITE_ASSET__D_alLGA9__"